import {Directive, ElementRef, EventEmitter, HostListener, OnInit, Output} from '@angular/core';
import {fromEvent} from 'rxjs';
import {take} from 'rxjs/operators';

@Directive({
	selector: '[appClickOutside]',
})
export class ClickOutsideDirective implements OnInit {
	@Output() public clickOutside = new EventEmitter();

	public captured = false;

	constructor(private elRef: ElementRef) {
	}

	@HostListener('document:click', ['$event.target'])
	public onClick(target): void {
		if (!this.captured) {
			return;
		}

		if (!this.elRef.nativeElement.contains(target)) {
			this.clickOutside.emit();
		}
	}

	public ngOnInit(): void {
		fromEvent(document, 'click', {capture: true}).pipe(take(1))
			.subscribe(() => this.captured = true);
	}
}
